<div class="m-shell" [class.m-shell--collapsed]="collapsed">

  <app-modern-sidebar [mobileOpen]="mobileOpen"
                      (collapsedChange)="onCollapsedChange($event)"
                      (closeRequested)="closeMobileMenu()">
  </app-modern-sidebar>

  <!-- mobil çekmece karartması -->
  <div class="m-backdrop" *ngIf="mobileOpen" (click)="closeMobileMenu()"></div>

  <div class="m-main">
    <app-modern-topbar (mobileMenuButtonClicked)="toggleMobileMenu()"></app-modern-topbar>

    <main class="m-content">
      <router-outlet></router-outlet>
    </main>

    <app-modern-footer></app-modern-footer>
  </div>
</div>
